<app-header></app-header>

<section class="container-xxl">

     <!-- BREADCRUMB AREA - STARTS -->
     <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{ "Home" | translate}}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Employee Corner':'कर्मचारी कॉर्नर'" routerLink="/employeecorner/">{{'EmployeeCorner' | translate}}</a></li>

                <li class="breadcrumb-item active screen-reader" >{{'TransaferPostingOrder'  | translate}}</li>
            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

   
    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                      </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                        <h2 class="screen-reader" id="officeTable">{{ 'PostingTransfer' | translate }}</h2>

                                        <a [attr.title]="language=='English'?'Go to Archive Posting,transfer and promotions order':'संग्रहीत पोस्टिंग, स्थानांतरण एवं पदोन्नति आदेश पर जाएँ'" [routerLink]="'/archive-posting-transfer-promotions-order'" class="btn btn-sm btn-outline-success screen-reader" >
                                            <i class="bi bi-archive me-2"></i> {{ 'archivepostingtransfer' | translate }}
                                        </a>
                                    </div>
                                    <div class="description">
                                        <div class="tenders">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <!-- search section -->
                                                   
                                                    <div class="searchpanel notific-frm" *ngIf="issearch == true || isdisplay == true">
                                                        <form [formGroup]="searchForm" (ngSubmit)="searchContact()">
                                                            <div class="row">
                                                            
                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ 'Keywords' | translate }}</b>
                                                                        </label>
                                                                        <input type="text" formControlName="name" #name class="form-control screen-reader" >
                                                                    </div>
                                                                </div>

                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ 'PublishOrderDate' | translate }}</b>
                                                                        </label>
                                                                        <input type="date" formControlName="p_date" #p_date class="form-control screen-reader" >
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    class="col-xl-2 col-md-12 col-sm-6 col-xs-12 d-flex align-items-end">
                                                                    <div class="d-flex align-items-center gap-3 mt-3">
                                                                        <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'"
                                                                            class="btn btn-outline-success screen-reader"
                                                                            [disabled]="ifdisabled"
                                                                            [innerHTML]="btncontent">
                                                                        </button>
                                                                        <div *ngIf="RefreshBtn">
                                                                            <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'"
                                                                                class="btn btn-outline-secondary py-0-2 screen-reader"
                                                                                (click)="RefreshPage()">
                                                                                <i class="bi bi-arrow-repeat fs-5"
                                                                                    aria-hidden="true"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div> 
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <!-- search section -->

                                                    <!-- tender section area -->


                                                    <div class="table-responsive font-adjust">
                                                        <table class="table" aria-describedby="officeTable" *ngIf="orderList && orderList.length > 0; else noDataTemplate">
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th class="screen-reader" scope="col">{{ 'SlNo' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'Posting_Transfer' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'Month' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'PublishOrderDate' | translate }}</th>
                                                                </tr>
                                                            </thead>
                                     <tbody>
                                
                                     <tr *ngFor="let item of orderList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};let x=index;" >
                                    <td class="screen-reader" *ngIf="currentPage==1">{{x+1}}</td>
                                    <td class="screen-reader" *ngIf="currentPage>1">{{(limit*(currentPage-1)) + (x+1)}}</td>
                                           
                                    <td class="screen-reader">
                                    
                                    <a [href]="backend_url+'storage/app/uploads/'+item.selectDocument"
                                    [download]="item.selectDocument"
                                    title="{{ item.fileType}}" target="_blank" *ngIf="checkFileExists(item)">
                                        {{ language=='English'?item.documentTitle:item.documentTitleInHindi }}
                                     
                                        || {{item.selectDocument_details.fileSize }}
                                        <span style="text-transform: uppercase;" *ngIf="checkFileType(item)!==false" [innerHtml]="checkFileType(item).file"></span>
                                            {{item.dtmCreatedOn | date:'MMM d, y'}}
                                    </a>
                                    <label *ngIf="checkFileExists(item)==false">
                                        {{ language=='English'?item.documentTitle:item.documentTitleInHindi }}
                                    </label>
                                    </td>
                                    <td class="screen-reader">{{ getMonth(item.publishOrderDate | date: 'MMMM')}}</td>
                                    <td class="screen-reader">{{ getMonth(item.publishOrderDate | date: 'MMMM')}} {{ item.publishOrderDate | date: 'd, y'}}</td>
                                </tr>
                            </tbody> 
                                                        </table>

                                                        <ng-template #noDataTemplate>
                           
                                                            <p class="screen-reader font-adjust" [style.text-align]="'center'"><b>{{'Nodataavailable'|translate}}</b></p>
                                    
                                                          </ng-template>
                                                        <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 10"></pagination-controls>
                                                    </div>
                                             
 
                                                    <!-- tender section area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>